"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
var ServiceError_1 = require("./ServiceError");
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.headers = headers;
        _this.result = result;
        _this.serviceError = response
            ? new ServiceError_1.ServiceError(response.error)
            : undefined;
        return _this;
    }
    ApiException.prototype.getFieldError = function (name) {
        if (this.serviceError) {
            return this.serviceError.getFieldError(name);
        }
        return undefined;
    };
    ApiException.prototype.toString = function () {
        if (this.serviceError) {
            return this.serviceError.toString();
        }
        return this.message;
    };
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
exports.ApiException = ApiException;
//# sourceMappingURL=ApiException.js.map